import axios from 'axios';
import index from './index';

export default {
  getVideos() {
    return axios.get(`/modules/${index.api}/`);
  },
};
